import { Button, ButtonRow, Heading, Text } from '@ksyos/design-system';
import { IntroContainer } from '../../../../elements/molecules/introContainer/IntroContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';

export function ProcedureSentMessage() {
    return (
        <IntroContainer style={{ textAlign: 'center' }}>
            <Stack>
                <img
                    alt="Success"
                    src="/assets/images/derma-oth/success.svg"
                    style={{ maxWidth: '60%' }}
                />
            </Stack>
            <Stack>
                <Heading size="xlarge">Je antwoorden zijn verzonden</Heading>
            </Stack>
            <Stack>
                <Text>
                    Je huisarts gaat jouw antwoorden bekijken. De huisarts zal je bellen om jouw situatie te bespreken.
                    Houd daarom je telefoon bij de hand.
                </Text>
            </Stack>
            <Stack>
                <ButtonRow justify="center">
                    <Button
                        color="secondary"
                        onClick={() => (window.location.href = '/')}
                        variant="solid"
                        width="full-below-small"
                    >
                        Terug naar Home
                    </Button>
                </ButtonRow>
            </Stack>
        </IntroContainer>
    );
}
